import { ApplicationConfig, provideBrowserGlobalErrorListeners, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { CUSTOS_ENVIRONMENT } from './core/models/environment';
import { environment } from '../environments/environment';
import { provideApiService } from './core/api/api.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    // TranslateModule.forRoot provides TranslateStore, TranslateService, TranslatePipe, etc.
    // It also provides TranslateNoOpLoader by default which we override below.
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        fallbackLang: 'en',
      }),
    ),
    // provideTranslateHttpLoader MUST come AFTER forRoot to override the NoOpLoader
    ...provideTranslateHttpLoader({ prefix: '/assets/i18n/' }),
    { provide: CUSTOS_ENVIRONMENT, useValue: environment },
    ...provideApiService(),
  ],
};
